import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header/header';
import FooterSection from '../components/Footer';
import SubscribeSection from '../components/Subscribe';
import { getPost, getPostsByCategory } from '../services/postService';
import FAQAccordion from '../components/FAQAccordion';

const SITE_URL = 'https://exploroff.com';

// Fallback Google Maps embed URLs for itinerary posts that don't store mapEmbedUrl in Firebase.
// Use post.mapEmbedUrl first; fall back to this map.
const ITINERARY_MAP_FALLBACKS = {
  'appalachian-trail-shenandoah':
    'https://maps.google.com/maps?saddr=Front+Royal,+VA&daddr=Skyline+Drive,+Shenandoah+National+Park,+VA+to:Big+Meadows,+Shenandoah+National+Park,+VA+to:Blackrock+Summit,+VA+to:Rockfish+Gap,+VA&output=embed',
  'bryce-canyon-itinerary':
    'https://maps.google.com/maps?saddr=Bryce+Canyon+City,+UT&daddr=Bryce+Canyon+Visitor+Center,+UT+to:Sunrise+Point,+Bryce+Canyon,+UT+to:Navajo+Loop+Trail,+Bryce+Canyon,+UT+to:Fairyland+Loop+Trailhead,+Bryce+Canyon,+UT&output=embed',
  'canyonlands-needles-backpacking':
    'https://maps.google.com/maps?saddr=Monticello,+UT&daddr=Needles+Visitor+Center,+Canyonlands,+UT+to:Squaw+Flat+Trailhead,+UT+to:Chesler+Park,+Canyonlands,+UT+to:Joint+Trail,+Canyonlands,+UT&output=embed',
  'capitol-reef-itinerary':
    'https://maps.google.com/maps?saddr=Torrey,+UT&daddr=Capitol+Reef+Visitor+Center,+UT+to:Fruita+Campground,+Capitol+Reef,+UT+to:Cassidy+Arch+Trail,+Capitol+Reef,+UT+to:Hickman+Bridge+Trail,+Capitol+Reef,+UT&output=embed',
  'isle-royale-backpacking':
    'https://maps.google.com/maps?saddr=Houghton,+MI&daddr=Rock+Harbor,+Isle+Royale+National+Park,+MI+to:Greenstone+Ridge+Trail,+Isle+Royale,+MI+to:Windigo,+Isle+Royale+National+Park,+MI&output=embed',
  'john-muir-trail-section':
    'https://maps.google.com/maps?saddr=Yosemite+Valley,+CA&daddr=Happy+Isles+Trailhead,+Yosemite,+CA+to:Little+Yosemite+Valley,+CA+to:Tuolumne+Meadows,+CA+to:Reds+Meadow,+CA&output=embed',
  'kings-canyon-backpacking':
    'https://maps.google.com/maps?saddr=Fresno,+CA&daddr=Kings+Canyon+Visitor+Center,+CA+to:Roads+End,+Kings+Canyon+National+Park,+CA+to:Mist+Falls+Trail,+Kings+Canyon,+CA+to:Paradise+Valley,+Kings+Canyon,+CA&output=embed',
  'north-cascades-backpacking':
    'https://maps.google.com/maps?saddr=Sedro-Woolley,+WA&daddr=North+Cascades+Visitor+Center,+WA+to:Maple+Pass+Loop+Trailhead,+WA+to:Sahale+Arm+Trail,+WA+to:Diablo+Lake+Overlook,+WA&output=embed',
  'olympic-national-park-itinerary':
    'https://maps.google.com/maps?saddr=Port+Angeles,+WA&daddr=Hurricane+Ridge,+Olympic+National+Park,+WA+to:Hoh+Rain+Forest,+Olympic+National+Park,+WA+to:Ruby+Beach,+Olympic+National+Park,+WA+to:Sol+Duc+Falls,+Olympic+National+Park,+WA&output=embed',
  'pictured-rocks-backpacking':
    'https://maps.google.com/maps?saddr=Munising,+MI&daddr=Miners+Beach,+Pictured+Rocks,+MI+to:Miners+Castle,+Pictured+Rocks,+MI+to:Chapel+Falls,+Pictured+Rocks,+MI+to:Grand+Sable+Dunes,+MI&output=embed',
  'adirondack-high-peaks':
    'https://maps.google.com/maps?saddr=Lake+Placid,+NY&daddr=Adirondack+Loj,+NY+to:Mount+Marcy+Summit,+NY+to:Heart+Lake,+Adirondacks,+NY+to:Algonquin+Peak,+NY&output=embed',
  'big-sur-hiking':
    'https://maps.google.com/maps?saddr=Carmel-by-the-Sea,+CA&daddr=Point+Lobos+State+Reserve,+CA+to:Pfeiffer+Big+Sur+State+Park,+CA+to:McWay+Falls,+Big+Sur,+CA+to:Julia+Pfeiffer+Burns+State+Park,+CA&output=embed',
  'crater-lake-rim-trail':
    'https://maps.google.com/maps?saddr=Crater+Lake+Visitor+Center,+OR&daddr=Rim+Village,+Crater+Lake,+OR+to:Discovery+Point+Trail,+Crater+Lake,+OR+to:Watchman+Overlook,+Crater+Lake,+OR&output=embed',
  'death-valley-winter-hiking':
    'https://maps.google.com/maps?saddr=Las+Vegas,+NV&daddr=Furnace+Creek+Visitor+Center,+Death+Valley,+CA+to:Badwater+Basin,+Death+Valley,+CA+to:Mesquite+Flat+Sand+Dunes,+Death+Valley,+CA+to:Mosaic+Canyon,+Death+Valley,+CA&output=embed',
  'grand-teton-day-hikes':
    'https://maps.google.com/maps?saddr=Jackson,+WY&daddr=Jenny+Lake+Visitor+Center,+Grand+Teton,+WY+to:Cascade+Canyon+Trail,+Grand+Teton,+WY+to:String+Lake,+Grand+Teton,+WY+to:Taggart+Lake+Trailhead,+WY&output=embed',
  'guadalupe-mountains-hiking':
    'https://maps.google.com/maps?saddr=El+Paso,+TX&daddr=Guadalupe+Mountains+Visitor+Center,+TX+to:Guadalupe+Peak+Trailhead,+TX+to:The+Pinery+Trail,+Guadalupe+Mountains,+TX&output=embed',
  'haleakala-sunrise-hike':
    'https://maps.google.com/maps?saddr=Kahului,+HI&daddr=Haleakala+Visitor+Center,+HI+to:Haleakala+Summit,+HI+to:Sliding+Sands+Trail,+Haleakala,+HI&output=embed',
  'lassen-volcanic-day-hikes':
    'https://maps.google.com/maps?saddr=Lassen+Volcanic+National+Park+Visitor+Center,+CA&daddr=Bumpass+Hell+Trail,+Lassen,+CA+to:Lassen+Peak+Trailhead,+CA+to:Boiling+Springs+Lake,+Lassen,+CA&output=embed',
  'mount-whitney-trail':
    'https://maps.google.com/maps?saddr=Lone+Pine,+CA&daddr=Whitney+Portal+Trailhead,+CA+to:Trail+Camp,+Mount+Whitney,+CA+to:Mount+Whitney+Summit,+CA&output=embed',
};

class DynamicPost extends Component {
  state = { post: null, loading: true, notFound: false, related: [] };

  componentDidMount() {
    const { slug } = this.props.match.params;
    getPost(slug).then(post => {
      if (!post || post.isStatic) {
        this.setState({ notFound: true, loading: false });
      } else {
        this.setState({ post, loading: false });
        getPostsByCategory(post.category).then(posts => {
          const related = posts.filter(p => p.id !== slug).slice(0, 3);
          this.setState({ related });
        }).catch(() => {});
      }
    }).catch(() => this.setState({ notFound: true, loading: false }));
  }

  render() {
    const { post, loading, notFound, related } = this.state;

    if (loading) {
      return (
        <>
          <Header bgColor="teal" />
          <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="xpost-spinner" />
          </div>
          <FooterSection />
        </>
      );
    }

    if (notFound) {
      return (
        <>
          <Header bgColor="teal" />
          <div style={{ minHeight: '70vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '16px', paddingTop: '80px' }}>
            <h1 style={{ color: '#004858', fontSize: '2rem', fontWeight: '800' }}>Trail Not Found</h1>
            <p style={{ color: '#666', fontSize: '1rem' }}>This post doesn't exist or has been moved.</p>
            <a href="/hiking-guides" style={{ color: '#004858', fontWeight: '700', textDecoration: 'none' }}>
              ← Back to Hiking Guides
            </a>
          </div>
          <FooterSection />
        </>
      );
    }

    const canonicalUrl = `${SITE_URL}/${post.category}/${post.id}`;
    const publishedDate = post.publishedAt?.toDate?.()?.toISOString?.() || new Date().toISOString();

    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: post.metaTitle || post.title,
      description: post.metaDescription || post.excerpt,
      url: canonicalUrl,
      image: post.ogImage ? `${SITE_URL}${post.ogImage}` : post.coverImage ? `${SITE_URL}${post.coverImage}` : undefined,
      author: { '@type': 'Organization', name: post.author || 'ExplorOFF' },
      publisher: {
        '@type': 'Organization',
        name: 'ExplorOFF',
        url: SITE_URL,
        logo: { '@type': 'ImageObject', url: `${SITE_URL}/img/logo-color-1x.png` },
      },
      datePublished: publishedDate,
      dateModified: publishedDate,
      keywords: (post.keywords || []).join(', '),
      mainEntityOfPage: { '@type': 'WebPage', '@id': canonicalUrl },
    };

    const isHowTo = /^how\s+to\b/i.test(post.title);
    const howToSchema = isHowTo ? {
      '@context': 'https://schema.org',
      '@type': 'HowTo',
      name: post.title,
      description: post.metaDescription || post.excerpt || '',
      url: canonicalUrl,
      ...(post.readTime && { totalTime: `PT${parseInt(post.readTime, 10)}M` }),
    } : null;

    const faqSchema = post.faqs && post.faqs.length > 0 ? {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: post.faqs.map(f => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    } : null;

    const categoryLabel = post.category === 'hiking-guides' ? 'Hiking Guides' : 'Itineraries';
    const categoryPath = post.category === 'hiking-guides' ? '/hiking-guides' : '/itineraries';

    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home',        item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: categoryLabel, item: `${SITE_URL}${categoryPath}` },
        { '@type': 'ListItem', position: 3, name: post.title,    item: canonicalUrl },
      ],
    };

    return (
      <>
        <Helmet>
          <title>{post.metaTitle || post.title}</title>
          <meta name="description" content={post.metaDescription || post.excerpt || `${post.title} — curated outdoor guide from ExplorOFF.`} />
          <meta property="og:title" content={post.metaTitle || post.title} />
          <meta property="og:description" content={post.metaDescription || post.excerpt} />
          <meta property="og:url" content={canonicalUrl} />
          <meta property="og:type" content="article" />
          {(post.ogImage || post.coverImage) && (
            <meta property="og:image" content={`${SITE_URL}${post.ogImage || post.coverImage}`} />
          )}
          <meta name="twitter:card" content="summary_large_image" />
          <link rel="canonical" href={canonicalUrl} />
          <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
          <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
          {howToSchema && (
            <script type="application/ld+json">{JSON.stringify(howToSchema)}</script>
          )}
          {faqSchema && (
            <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
          )}
        </Helmet>

        <Header bgColor="teal" />

        {/* Hero — itineraries use text-only header; map renders below */}
        {post.coverImage && post.category !== 'itineraries' ? (
          <div className="xpost-hero">
            <img
              src={post.coverImage}
              alt={post.title}
              className="xpost-hero-img"
              loading="eager"
            />
            <div className="xpost-hero-overlay">
              <div className="container">
                <nav className="xpost-breadcrumb" aria-label="breadcrumb">
                  <a href="/">Home</a>
                  <i className="ti-angle-right" />
                  <a href={categoryPath}>{categoryLabel}</a>
                  <i className="ti-angle-right" />
                  <span>{post.title}</span>
                </nav>
                <h1 className="xpost-title">{post.title}</h1>
                {post.excerpt && <p className="xpost-excerpt">{post.excerpt}</p>}
                <div className="xpost-meta">
                  {post.readTime && (
                    <span><i className="ti-timer" style={{ marginRight: '4px' }} />{post.readTime} min read</span>
                  )}
                  {post.region && (
                    <span><i className="ti-location-pin" style={{ marginRight: '4px' }} />{post.region}</span>
                  )}
                  {post.difficulty && (
                    <span><i className="ti-flag-alt" style={{ marginRight: '4px' }} />{post.difficulty}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="xpost-no-hero">
            <div className="container">
              <nav className="xpost-breadcrumb xpost-breadcrumb-dark" aria-label="breadcrumb">
                <a href="/">Home</a>
                <i className="ti-angle-right" />
                <a href={categoryPath}>{categoryLabel}</a>
                <i className="ti-angle-right" />
                <span>{post.title}</span>
              </nav>
              <h1 className="xpost-title-plain">{post.title}</h1>
              {post.excerpt && <p className="xpost-excerpt-plain">{post.excerpt}</p>}
            </div>
          </div>
        )}

        {/* Google Map route — every itinerary gets a map */}
        {(() => {
          const mapUrl = post.mapEmbedUrl || ITINERARY_MAP_FALLBACKS[post.id];
          return mapUrl ? (
            <section style={{ background: '#f0f4f6' }}>
              <iframe
                src={mapUrl}
                width="100%"
                height="420"
                title={`${post.title} route map`}
                style={{ display: 'block', border: 0 }}
                loading="lazy"
                allowFullScreen
              />
            </section>
          ) : null;
        })()}

        {/* Body */}
        <div className="xpost-body">
          <div className="container">
            <div className="xpost-grid">

              <article className="xpost-content">
                <div dangerouslySetInnerHTML={{ __html: post.content }} />
                {post.faqs && post.faqs.length > 0 && (
                  <FAQAccordion
                    title={post.faqTitle || `${post.title} FAQs`}
                    items={post.faqs.map(faq => ({
                      q: faq.q || faq.question || faq.Question || faq.text || faq.heading || '',
                      a: faq.a || faq.answer || faq.Answer || faq.body || faq.description || faq.content || '',
                    }))}
                  />
                )}
              </article>

              <aside className="xpost-sidebar">
                <div className="xpost-sidebar-card xpost-sidebar-cta-card">
                  <div className="xpost-sidebar-cta-icon">
                    <i className="ti-map-alt" />
                  </div>
                  <h4>Share Your Route</h4>
                  <p>Been Somewhere Epic? Submit your itinerary and inspire the ExplorOFF community.</p>
                  <a href="/submit-itinerary" className="xpost-sidebar-cta-btn">
                    Submit Your Itinerary
                  </a>
                </div>

                <div className="xpost-sidebar-card xpost-sidebar-tour-card">
                  <img
                    src="/img/chain-lakes-loop/chain-lakes-loop.webp"
                    alt="Guided Hiking Tour in the Pacific Northwest"
                    className="xpost-sidebar-tour-img"
                  loading="lazy" />
                  <div className="xpost-sidebar-tour-body">
                    <div className="xpost-sidebar-tour-price">$170</div>
                    <div className="xpost-sidebar-tour-divider" />
                    <h4>Guided Hike in Washington</h4>
                    <p>Experience the Pacific Northwest responsibly on a guided hiking adventure. Small-group sustainable hikes on Washington's most beautiful trails, 4–6 miles long. Learn Leave No Trace principles and responsible wildlife practices along the way.</p>
                    <a
                      href="https://www.airbnb.com/experiences/4670214?s=67&unique_share_id=5260d3e2-6b0d-4b14-9a9d-5a3f48aa93c7"
                      className="xpost-sidebar-tour-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Book Now — $170
                    </a>
                  </div>
                </div>

                {post.trailStats && (
                  <div className="xpost-sidebar-card">
                    <h4>Trail Stats</h4>
                    <div className="xpost-stats">
                      {post.trailStats.distance && (
                        <div className="xpost-stat">
                          <span className="xpost-stat-label">Distance</span>
                          <span className="xpost-stat-value">{post.trailStats.distance}</span>
                        </div>
                      )}
                      {post.trailStats.gain && (
                        <div className="xpost-stat">
                          <span className="xpost-stat-label">Elevation Gain</span>
                          <span className="xpost-stat-value">{post.trailStats.gain}</span>
                        </div>
                      )}
                      {post.trailStats.difficulty && (
                        <div className="xpost-stat">
                          <span className="xpost-stat-label">Difficulty</span>
                          <span className="xpost-stat-value">{post.trailStats.difficulty}</span>
                        </div>
                      )}
                      {post.trailStats.time && (
                        <div className="xpost-stat">
                          <span className="xpost-stat-label">Typical Time</span>
                          <span className="xpost-stat-value">{post.trailStats.time}</span>
                        </div>
                      )}
                      {post.trailStats.season && (
                        <div className="xpost-stat">
                          <span className="xpost-stat-label">Best Season</span>
                          <span className="xpost-stat-value">{post.trailStats.season}</span>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {post.tags && post.tags.length > 0 && (
                  <div className="xpost-sidebar-card">
                    <h4>Tags</h4>
                    <div className="xpost-tags-list">
                      {post.tags.map(t => (
                        <span key={t} className="xpost-tag-pill">{t}</span>
                      ))}
                    </div>
                  </div>
                )}

                <div className="xpost-sidebar-card xpost-browse-card">
                  <h4>Explore More</h4>
                  <a href="/hiking-guides" className="xpost-browse-link">
                    <i className="ti-map" /> All Hiking Guides
                  </a>
                  <a href="/itineraries" className="xpost-browse-link">
                    <i className="ti-location-pin" /> All Itineraries
                  </a>
                </div>
              </aside>

            </div>
          </div>
        </div>

        {related.length > 0 && (
          <div className="xrelated-section">
            <div className="container">
              <h3 className="xrelated-title">More to Explore</h3>
              <div className="xrelated-grid">
                {related.map(r => (
                  <a key={r.id} href={`/${r.category}/${r.id}`} className="xrelated-card">
                    {r.coverImage && (
                      <img src={r.coverImage} alt={r.title} className="xrelated-card-img" loading="lazy" />
                    )}
                    <div className="xrelated-card-body">
                      <h4 className="xrelated-card-title">{r.title}</h4>
                      {r.excerpt && <p className="xrelated-card-excerpt">{r.excerpt}</p>}
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}

        <SubscribeSection />
        <FooterSection />
      </>
    );
  }
}

export default DynamicPost;
